/**
 * Default reducer for data
 */
import actionTypes from '../../actions/actionTypes';


function isIncluded(container, obj) {
  return Object.entries(obj).every(([key, value]) => {
    const subContainer = container[key];

    return value === container[key] ||
      typeof value === 'object' && !!subContainer && isIncluded(subContainer, value);
  });
}

function removeData(dataToDelete, state) {
  if (!dataToDelete || dataToDelete.length === 0) {
    return state;
  }

  const newState = { ...state };
  dataToDelete.forEach(({ id }) => {
    delete newState[id];
  });

  return newState;
}

function toggleFollow(state, action) {
  const id = action.follow.id;
  const oldData = state[id] || {};
  const isFollowing = oldData.isFollowing;

  return { [id]: { ...oldData, isFollowing: !isFollowing } };
}

// in object modification because the object has been cloned before
function mergeData(data, oldState, basicElement, assign) {
  if (!data) {
    return oldState;
  }

  const state = {};
  let hasChanged = false;
  Object.entries(data).forEach(([id, item]) => {
    const oldElement = oldState[id] || basicElement;
    if (
      oldElement === basicElement ||
      !isIncluded(oldElement, item)
      ) {
      state[id] = assign({}, oldElement, item);
      hasChanged = true;
    }
  });

  return hasChanged ? { ...oldState, ...state } : oldState;
}

export default function (dataName, basicElement = {}, assign = () => Object.assign) {
  return (state = {}, action) => {
    switch (action.type) {
      case actionTypes.LOG_OUT:
      case actionTypes.PROFILE_DELETE:
        return {};
      case actionTypes.FOLLOW_TOGGLE:
      case actionTypes.FOLLOW_TOGGLE_FAILURE:
        if (action.follow.type !== dataName) {
          return state;
        }
        return Object.assign({}, state, toggleFollow(state, action));
      default:
        break;
    }

    const reducedState = removeData(
      action && action.dataToDelete && action.dataToDelete[dataName],
      state
    );
    return mergeData(
      action && action.data && action.data[dataName],
      reducedState,
      basicElement,
      assign(action),
    );
  };
}



// WEBPACK FOOTER //
// ./~/virgo/src/reducers/data/dataReducerGenerator.js